import { useLoggedInUser } from "components/LoggedInUserProvider";
import React from "react";

import TrainerWorkouts from "./Trainer";
import VetWorkoutsPage from "./Vet";

const WorkoutsPage = () => {
  const { currentUser } = useLoggedInUser();

  if (currentUser.isTrainer || currentUser.isRacingOfficial) {
    return <TrainerWorkouts />;
  }
  if (currentUser.isVeterinarian || currentUser.isAdmin) {
    return <VetWorkoutsPage />;
  }

  return <></>;
};

export default WorkoutsPage;
